import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ListeComponent } from '../liste/liste.component';
import { GeneralService } from '../services/general.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic'; 
import { AngularEditorConfig } from '@kolkov/angular-editor';
declare var $ : any
@Component({
  selector: 'app-link-component',
  templateUrl: './link-component.component.html',
  styleUrls: ['./link-component.component.scss']
})
export class LinkComponentComponent implements OnInit {

  constructor(private generaleService : GeneralService,private dialog: MatDialog) { }
  @ViewChild("listeLienMosaiqueComponen") listeLienMosaiqueComponen : ListeComponent;
  @ViewChild("listeLienEtVideoComponen") listeLienEtVideoComponen : ListeComponent;
  @ViewChild("content") content;
  urlVideo : string ;
  titreVideo : string ;
  descriptionVideo : string ;
  listBtnLienMosaique:Array<any> = 
  [
    {name:"ajouter",class:"colorBlue",text:"Ajouter imague",disabled:false,icon:"add"},
    {name:"supprimer",class:"colorRed",text:"Supprimer",disabled:false,icon:"delete"}
  ]
  columns=
  {
    "TableRD":
    [
      // {"TableRE_Code":"","TableRD_Champs":"File_Text","Lg_Code":"","TableRD_Des":"Titre","TableRD_Largeur":100,"TableRD_ReadOnly":false,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":2,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {"TableRE_Code":"","TableRD_Champs":"File_Content","Lg_Code":"","TableRD_Des":"Image","TableRD_Largeur":150,"TableRD_ReadOnly":true,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":1,"TableRD_Type":7,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null}
    ]
  }
  listBtnLienEtVideo = [{name:"ajouterVideo",class:"colorBlue",text:"Ajouter vidéo",disabled:false,icon:"delete"}].concat(this.listBtnLienMosaique)
  listeImagesLienMosaique = [];
  listeImagesLienEtVideo = [];
  enregistrementTerminer : boolean = true;
  selectedId : string = ""
  dialogRef;
  isLoadetImageContentLienMosaique = false
  isLoadetImageContentLienEtVideo = false;
  indexActiveTabs : number=0;
  Editor = ClassicEditor;  
  imgLienPrincipal;
  dsImgLienPrincipal
  editorConfig: AngularEditorConfig = JSON.parse(JSON.stringify(this.generaleService.editorConfig)) ;
  listeLanguages = [];
  dsLanguage;
  imgLienPrincipalTextAnglais :string ="";
  imgLienMosaiqueTextAnglais :string ="";
  imgLienMosaiqueTextFrancais :string ="";
  imgLienEtVideoTextAnglais :string ="";
  imgLienEtVideoTextFrancais :string ="";
  selectedRow;
  ngOnInit() 
  {
    this.editorConfig.height = "auto";
    this.imgLienPrincipal = {};
    this.enregistrementTerminer = false;
    this.getListeImageLienMosaique();
    this.getListeImageLienEtVideo();
    this.getImageLienPrincipale();
  }
  getLanguage(language , code)
  {
    this.generaleService.rechercheTable("recherche/tbdata?tablere=Lg&param1=" + language+ "&param2=" + code).subscribe(data =>
    {
      this.listeLanguages.push(data) ;
    })
  }
  enregistrerLangue(data1 , langueFrancais, langueAnglais)
  {
    if(this.generaleService.isNotEmpty(langueFrancais) && this.generaleService.isNotEmpty(langueAnglais))
    {
      this.enregistrementTerminer = false;
        this.setDefaultLangue(data1.File_Id,langueFrancais);
        for(let i=0;i<2;i++)
        {
          this.generaleService.rechercheTable("recherche/tbdata?tablere=Lg&param=" + i + "," + data1.File_Id).subscribe(data2 =>
          {
            var text = langueFrancais;
            if(i == 1)
            {
              text = langueAnglais;
              this.enregistrementTerminer = true;
            }
            if(data2.length >0)
            {
              this.generaleService.modifierLanguage(data2[0].Lg_Id,text)
            }
            else
            {
              this.generaleService.enregistrerLanguage(data1.File_Id,i,text)
            }
          },()=>
          {
            this.enregistrementTerminer = true;
            this.generaleService.dialogSuccess("Non enregistrer",false)
          })
        }
      
    }
    else
        this.generaleService.dialogSuccess("Veuillez entrer les différentes langues",false)
  }
  setDefaultLangue(File_Id,File_Text)
  {
    this.generaleService.rechercheTable(this.generaleService.urlFiles+"&val="+ File_Id).subscribe( file =>
    {
      file.Files[0].File_Text = File_Text;
      this.generaleService.enregisterTable(file).subscribe(data =>
      {
        
        this.generaleService.dialogSuccess("Enregistrer",true)
      },()=>
      {
        this.generaleService.dialogSuccess("Non enregistrer",false)
      })
    });
  }
  
  selectImage(id:string)
  {    
    $("#LIEN-MOSAIQUE-1").attr("style","");
    $("#LIEN-MOSAIQUE-2").attr("style","");
    $("#LIEN-MOSAIQUE-3").attr("style","");
    $("#LIEN-MOSAIQUE-4").attr("style","");
    $("#LIEN-MOSAIQUE-5").attr("style","");
    $("#LIEN-MOSAIQUE-"+id).attr("style","border-color: rgb(29, 35, 90);   border-style: solid;");
    this.selectedId = id
  }
  showListeImageMosaiqie(id:string)
  {
    this.selectImage(id);
    this.listeLienMosaiqueComponen.setDataSource(this.genererImageHtml(this.listeImagesLienMosaique.filter(art =>{return art.File_Groupe == this.selectedId.toString()})));
  }
  showListeLienEtDieo()
  {
    this.listeLienEtVideoComponen.setDataSource(this.genererImageHtml(this.listeImagesLienEtVideo));
  }
  genererImageHtml(listeImage)
  {
    var images =JSON.parse( JSON.stringify(listeImage))
    images.forEach(image =>
    {
      if(this.generaleService.isNotEmpty(image.File_Content))
      {
        if(image.File_Groupe != "VIDEO")
          image.File_Content =  "<img src='"+ image.File_Content + "' style='width : 150px;' >";
        else
        {
          var code : string;
          var pos1 = image.File_Content.indexOf("watch?v=")
          code =  image.File_Content.substring(pos1 + 8,pos1+19);
          image.File_Content = '<iframe width="90%" src="https://www.youtube.com/embed/'+code+'"  frameborder="0"  allowfullscreen></iframe>'
        }
      }
      
    });
    return images;
  }
  getImageLienPrincipale()
  {
    this.generaleService.rechercheTable(this.generaleService.url+ "avtFilesType&param=LIEN-PRINCIPALE").subscribe( img =>
    {
      if(img.length>0)
      {
        this.imgLienPrincipal = img[0];
        this.getImageContenetLienPrincipale();
        this.getLangueLienPrincipale();
      }
      else
      {
        this.generaleService. rechercheTable(this.generaleService.urlFiles).subscribe(doc =>
        {
          this.dsImgLienPrincipal = doc;
        });
      }
    });
  }
  getLangueLienPrincipale()
  {
    this.generaleService.rechercheTable("recherche/tbdata?tablere=Lg&param=1," + this.imgLienPrincipal.File_Id).subscribe(data =>
    {
      if(data.length>0)
        this.imgLienPrincipalTextAnglais = data[0].Lg_Libelle
    });
  }
  getImageContenetLienPrincipale()
  {
    this.generaleService.rechercheTable(this.generaleService.urlFiles+"&val="+ this.imgLienPrincipal.File_Id).subscribe( file =>
    {
      this.imgLienPrincipal.File_Content =file.Files[0].File_Content;
      this.imgLienPrincipal.File_Text =file.Files[0].File_Text;
      this.dsImgLienPrincipal = file;
    });
  }
  getImageContentLienEtVideo()
  {
    if( this.listeImagesLienEtVideo.length>0)
      for(let i=0;i< this.listeImagesLienEtVideo.length;i++)
      {
        this.generaleService.rechercheTable(this.generaleService.urlFiles+"&val="+ this.listeImagesLienEtVideo[i].File_Id).subscribe( file =>
        {
          this.listeImagesLienEtVideo[i].File_Content =file.Files[0].File_Content;
          this.showListeLienEtDieo();
          if(i+1 == this.listeImagesLienEtVideo.length)
          {
            this.isLoadetImageContentLienEtVideo = true;
            if(this.isLoadetImageContentLienMosaique)
              this.enregistrementTerminer = true;
          }
          // this.setBtnListeComponen(false)
        });
      }
    else
    {
      this.enregistrementTerminer = true;
      // this.setBtnListeComponen(false)
    }
    
  }
  getListeImageLienEtVideo()
  {
    this.listeImagesLienEtVideo = [];
    this.generaleService.rechercheTable(this.generaleService.url+ "avtFilesType&param=LIEN-ET-VIDEO").subscribe( img =>
    {
      this.listeImagesLienEtVideo = img;
     
      this.getImageContentLienEtVideo()
    });
  }
  getListeImageLienMosaique()
  {
    this.listeImagesLienMosaique = [];
    this.generaleService.rechercheTable(this.generaleService.url+ "avtFilesType&param=LIEN-MOSAIQUE").subscribe( img =>
    {
      this.listeImagesLienMosaique = img;
     
      this.getImageContentLienMosaique()
    });
  }
  getImageContentLienMosaique()
  {
    if( this.listeImagesLienMosaique.length>0)
      for(let i=0;i< this.listeImagesLienMosaique.length;i++)
      {
        this.generaleService.rechercheTable(this.generaleService.urlFiles+"&val="+ this.listeImagesLienMosaique[i].File_Id).subscribe( file =>
        {
          this.listeImagesLienMosaique[i].File_Content =file.Files[0].File_Content;
          if(this.selectedId != "" && this.listeLienMosaiqueComponen != undefined)
            this.showListeImageMosaiqie(this.selectedId);
          if(i+1 == this.listeImagesLienMosaique.length)
          {
            this.isLoadetImageContentLienMosaique = true
            if(this.isLoadetImageContentLienEtVideo)
              this.enregistrementTerminer = true;
          }
          // this.setBtnListeComponen(false)
        });
      }
    else
    {
      this.enregistrementTerminer = true;
      // this.setBtnListeComponen(false)
    }
    
  }
  clickBtnLienMosaique(event)
  {
    switch (event.name)
    {
      //imgLienMosaiqueTextFrancais
      case "supprimer":
      {
        this.supprimerImage();
        break;
      }
      case "save":
      {
        if(this.generaleService.isNotEmpty(this.listeLienMosaiqueComponen.row))
          this.enregsitrerImage(this.listeLienMosaiqueComponen.row.File_Id,this.listeLienMosaiqueComponen.row.File_Text,this.listeLienMosaiqueComponen.row.File_Dll);
        else
          this.generaleService.dialogSuccess("Veuillez sélectionner une image dans le tableau",false)
        break;
      }
      case "ajouter":
      {
        this.ajouterImage();
        break;
      }
      case "selectRow":
      {
        this.selectedRow = this.listeLienMosaiqueComponen.row;
        this.getLangueLienMosaique();
        break;
      }
    }
  }
  getLangueLienMosaique()
  {
    this.generaleService.rechercheTable("recherche/tbdata?tablere=Lg&param=0," + this.selectedRow.File_Id).subscribe(data =>
    {
      // Lien en mosaique défilent
      // if(this.indexActiveTabs == 1)
      // {
      //   if(data.length>0)
      //     this.imgLienMosaiqueTextFrancais = data[0].Lg_Libelle;
      //   else
      //     this.imgLienMosaiqueTextFrancais = "";
      //   }
      // Lien en image et video défilent
      if(this.indexActiveTabs == 1)
      {
        if(data.length>0)
          this.imgLienEtVideoTextFrancais = data[0].Lg_Libelle;
        else
          this.imgLienEtVideoTextFrancais = "";
      }
      
    });
    this.generaleService.rechercheTable("recherche/tbdata?tablere=Lg&param=1," + this.selectedRow.File_Id).subscribe(data =>
    {
      // Lien en mosaique défilent
      // if(this.indexActiveTabs == 1)
      // {
      //   if(data.length>0)
      //     this.imgLienMosaiqueTextAnglais = data[0].Lg_Libelle;
      //   else
      //     this.imgLienMosaiqueTextAnglais = ""
      // }
      // Lien en image et video défilent
      if(this.indexActiveTabs == 1)
      {
        if(data.length>0)
        this.imgLienEtVideoTextAnglais = data[0].Lg_Libelle;
      else
        this.imgLienEtVideoTextAnglais = ""
      }
      
    });
  }
  deleteFromImageLienEtVideo(event)
  {
    if(this.generaleService.isNotEmpty(this.listeLienEtVideoComponen.row))
    {
      this.setBtnListeComponen(true)
      this.enregistrementTerminer = false;
      var deleteFn = this.generaleService.supprimer(this.listeLienEtVideoComponen.row.File_Id,"avtFiles");
      if(deleteFn != null)
      {      
        deleteFn.subscribe(data =>
        {
          this.getListeImageLienEtVideo();
          this.setBtnListeComponen(false)
          this.enregistrementTerminer = true;
        });
      }
    }
    else
      this.generaleService.dialogSuccess("Veuillez sélectionner une image dans le tableau",false)
  }
  clickBtnLienEtVideo(event)
  {
    switch (event.name)
    {
      case "supprimer":
      {
        this.deleteFromImageLienEtVideo(event);
        break;
      }
      case "save":
      {
        if(this.generaleService.isNotEmpty(this.listeLienEtVideoComponen.row))
          this.enregsitrerImage(this.listeLienEtVideoComponen.row.File_Id,this.listeLienEtVideoComponen.row.File_Text,this.listeLienEtVideoComponen.row.File_Dll);
        else
          this.generaleService.dialogSuccess("Veuillez sélectionner une image dans le tableau",false)
        break;
      }
      case "ajouterVideo":
      {
        this.openFrmAjouterVideo()
        break;
      }
      case "ajouter":
      {
        this.ajouterImageLienEtVideo()
        break;
      }
      case "selectRow":
      {
        this.selectedRow = this.listeLienEtVideoComponen.row;
        this.getLangueLienMosaique();
        break;
      }
    }
  }
  ajouterImageLienEtVideo()
  {
        this.openWindowSelectImage()
  }
  openWindowSelectImage()
  {
    document.getElementById('input_file').click();
  }
  openFrmAjouterVideo()
  {
    
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.width = "450px";
      dialogConfig.height = "200px";
      // dialogConfig.data = activeRowInListeCommande.quantite;
      this.dialogRef = this.dialog.open(this.content, dialogConfig);            
   
  }
  async ajouterVideo()
  {
    this.dialogRef.close();
    this.enregistrementTerminer = false;
    this.setBtnListeComponen(true)
    await this.generaleService.addFiles(this.urlVideo,this.titreVideo,"","LIEN-ET-VIDEO","","","VIDEO","")
    
    this.getListeImageLienEtVideo();
    this.setBtnListeComponen(false);
  }
  async enregsitrerImage(File_Id,File_Text,File_Dll)
  {
    
    this.enregistrementTerminer = false;
    this.setBtnListeComponen(true)
    this.generaleService.rechercheTable("ds/formdata?code=avtFiles&val="+File_Id).subscribe(file =>
    {
      file.Files[0].File_Text = File_Text;
      file.Files[0].File_Dll = File_Dll;
      this.generaleService.enregisterTable(file).subscribe(()=>
      {
        this.enregistrementTerminer = true;
        this.setBtnListeComponen(false)
        this.generaleService.dialogSuccess("Enregistrer",true);
      })
    })
      
  }
  ajouterImage()
  {
    if(this.generaleService.isNotEmpty(this.selectedId))
    {
        document.getElementById('input_file').click();
    }
    else
      this.generaleService.dialogSuccess("Veuillez sélectionner un lien en mosaique",false)
  }
  setBtnListeComponen(action : boolean)
  {
    if(this.listeLienMosaiqueComponen)
      this.listeLienMosaiqueComponen.listBtn[0].disabled = action;
    // this.listeLienMosaiqueComponen.listBtn[1].disabled = action;
    // this.listeLienMosaiqueComponen.listBtn[2].disabled = action;

    if(this.listeLienEtVideoComponen)
    {
    this.listeLienEtVideoComponen.listBtn[0].disabled = action;
    this.listeLienEtVideoComponen.listBtn[1].disabled = action;
    this.listeLienEtVideoComponen.listBtn[2].disabled = action

    }
    // this.listeLienEtVideoComponen.listBtn[3].disabled = action
  }
  onChangeImagefile(fileInput)
  {    
    var current_file = fileInput.target.files[0];
    var reader = new FileReader();
    if (current_file.type.indexOf('image') == 0) 
    {
      this.enregistrementTerminer = false;
      this.setBtnListeComponen(true)

      reader.onload =  (e) =>
      {
        var image = new Image();
        image.src = reader.result.toString(); 
        image.onload  = (ev) =>
        {   
          this.addFiles(image,fileInput.target.files[0].name)
        }
      }
      reader.readAsDataURL(current_file);
    }
    else
      this.generaleService.dialogSuccess("Veuillez sélectionner une image",false)
  }
  async addFiles(image,File_Text)
  {
    var File_Content : string;
    var File_Type : string;
    var File_Groupe : string;
    //Lien principale
    if(this.indexActiveTabs == 0)
    {
      this.dsImgLienPrincipal.Files[0].File_Content = this.generaleService.redimentionnerImage(image,700,600,80);
      this.dsImgLienPrincipal.Files[0].File_Text = File_Text;
      this.dsImgLienPrincipal.Files[0].File_Type = "LIEN-PRINCIPALE";
      this.dsImgLienPrincipal.Files[0].File_Groupe = "IMAGE";
      this.generaleService.enregisterTable(this.dsImgLienPrincipal).subscribe(data =>
      {
        this.generaleService.dialogSuccess("Enregistrer",true);
        this.getImageContenetLienPrincipale();
        this.enregistrementTerminer = true;
      })
      return
    }
    // Lien en mosaique défilent
    // if(this.indexActiveTabs == 1)
    // {
    //   if(this.selectedId == "1")
    //     File_Content = this.generaleService.redimentionnerImage(image,700,600,80);
    //   else
    //     File_Content = this.generaleService.redimentionnerImage(image,350,300,80);

    //   File_Type = "LIEN-MOSAIQUE";
    //   File_Groupe = this.selectedId;
    // }
    //Lien et vidéo défilent
    if(this.indexActiveTabs == 1)
    {
      File_Content = this.generaleService.redimentionnerImage(image,400,270,80);
      File_Type = "LIEN-ET-VIDEO";
      File_Groupe = "IMAGE";
    }
    
    await this.generaleService.addFiles(File_Content,File_Text,"",File_Type,"","",File_Groupe,"");
    // if(this.indexActiveTabs == 1)
    //   this.getListeImageLienMosaique();
    if(this.indexActiveTabs == 1)
      this.getListeImageLienEtVideo();
  }
  supprimerImage()
  {
    if (this.generaleService.isNotEmpty(this.listeLienMosaiqueComponen.row)) 
    {
      var deleteFn = this.generaleService.supprimer(this.listeLienMosaiqueComponen.row.File_Id,"avtFiles");
      if(deleteFn != null)
      {
        this.enregistrementTerminer = false;
        this.setBtnListeComponen(true)
        deleteFn.subscribe(data => 
        {
          this.listeImagesLienMosaique = this.listeImagesLienMosaique.filter(file =>{return file.File_Id != this.listeLienMosaiqueComponen.row.File_Id});
          this.generaleService.dialogSuccess("Elément supprimer",true);
          this.listeLienMosaiqueComponen.setDataSource(this.genererImageHtml(this.listeImagesLienMosaique.filter(art =>{return art.File_Groupe == this.selectedId.toString()})));
          this.enregistrementTerminer = true;
          this.setBtnListeComponen(false)
        },
        error =>
        {
            this.generaleService.dialogSuccess("Elément non supprimé",false);
            this.enregistrementTerminer = true;
            this.setBtnListeComponen(false)
        });
      }
    }
    else
    this.generaleService.dialogSuccess("Veuillez sélectionner un article à supprimer",false)
  }
  
}

